import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=ef8c02e2&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8c02e2",
  null
  
)

export default component.exports